import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import style from "./Comment.module.sass";

function Comment(props) {
  const { id, text, translations } = props;
  const rootRef = useRef();

  useEffect(() => {
    // addListener();
  }, []);

  let rootClass = `${style.Comment}`;

  return (
    <div className={rootClass} id={`comment-${id}`} key={id} ref={rootRef}>
      <div className={style.header}>
        {translations.by}
      </div>
      <div className={style.text}>{text}</div>
    </div>
  );
}

Comment.propTypes = {};

Comment.defaultProps = {};

export default Comment;
